import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { reducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { CostModuleEffects } from './effects/cost-module.effects';

@NgModule({
  imports: [
    StoreModule.forFeature('costModule', reducers),
    EffectsModule.forFeature([
      CostModuleEffects
    ]),
  ]
})
export class CostModuleStoreModule {}
